import { ContentConfig } from "../types/ContentConfig";

const baseUrl = "/services/content";

class TenantService {
    async getTenant(): Promise<string> {
        const response = await fetch("/services/api/tenant/", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.text();
    }

    async getConfig(tenant: string): Promise<ContentConfig> {
        const response = await fetch(baseUrl + "/config/" + tenant + ".json", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.json();
    }
}

export default new TenantService();
